/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteDcrAttachmentMutationVariables = Types.Exact<{
	attachmentId: Types.Scalars['ID']['input'];
}>;

export type DeleteDcrAttachmentMutation = {
	__typename?: 'Mutation';
	deleteDcrAttachment:
		| { __typename: 'Forbidden' }
		| { __typename: 'NoContent'; message: string }
		| { __typename: 'ResourceNotFound'; message: string };
};

export const DeleteDcrAttachmentDocument = gql`
	mutation DeleteDcrAttachment($attachmentId: ID!) {
		deleteDcrAttachment(attachmentId: $attachmentId) {
			__typename
			... on NoContent {
				message
			}
			... on ResourceNotFound {
				message
			}
		}
	}
`;
export type DeleteDcrAttachmentMutationFn = Apollo.MutationFunction<
	DeleteDcrAttachmentMutation,
	DeleteDcrAttachmentMutationVariables
>;

/**
 * __useDeleteDcrAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteDcrAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDcrAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDcrAttachmentMutation, { data, loading, error }] = useDeleteDcrAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteDcrAttachmentMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DeleteDcrAttachmentMutation,
		DeleteDcrAttachmentMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DeleteDcrAttachmentMutation,
		DeleteDcrAttachmentMutationVariables
	>(DeleteDcrAttachmentDocument, options);
}
export type DeleteDcrAttachmentMutationHookResult = ReturnType<
	typeof useDeleteDcrAttachmentMutation
>;
export type DeleteDcrAttachmentMutationResult =
	Apollo.MutationResult<DeleteDcrAttachmentMutation>;
export type DeleteDcrAttachmentMutationOptions = Apollo.BaseMutationOptions<
	DeleteDcrAttachmentMutation,
	DeleteDcrAttachmentMutationVariables
>;
